import transparent from '@/assets/utils/transparent-img.js';
// ⚠️废弃
export default class Matting {
    /**
     * 构造函数
     *
     * @param base64
     */
    constructor(base64) {
        this.base64 = base64;
    }

    /**
     * 创建图片流
     */
    createStream() {
        return new Promise((res, rej) => {
            let img = new Image();
            img.src = this.base64;
            img.onload = () => {
                let c = document.createElement('canvas');
                c.width = img.width;
                c.height = img.height;
                let trimCanvas = '';

                try {
                    this.fitch(c, img);
                    trimCanvas = this.trim(c);
                    res(trimCanvas.toDataURL('image/png'));
                } catch (e) {
                    console.log(e);
                    // 如果默认抠图报错则换种方式
                    transparent?.methods?.transparentImg(this.base64).then(data => {
                        res(data);
                    });
                }

                c = null;
                trimCanvas = null;
            };
        })
    }

    /**
     * function 抠图逻辑
     *
     * @param width
     * @param height
     * @param c
     * @param img
     */
    fitch(c, img) {
        let width = c.width;
        let height = c.height;
        let ctx = c.getContext('2d');

        ctx.drawImage(img, 0, 0);
        /**
         * 取图片四个脚边的像素点rgba
         *
         * @type {*}
         */
        let tl = Array.prototype.slice.call(ctx.getImageData(0, 0, 1, 1).data).join(',');
        let tr = Array.prototype.slice.call(ctx.getImageData(width - 1, 0, 1, 1).data).join(',');
        let br = Array.prototype.slice.call(ctx.getImageData(width - 1, height - 1, 1, 1).data).join(',');
        let bl = Array.prototype.slice.call(ctx.getImageData(0, height - 1, 1, 1).data).join(',');
        let imgdata = [tl, tr, bl, br]; // 四个取色点
        let selfImageData = this.average(imgdata); // 设置要扣除的主题色
        let isPNG = true; // 判断是否已经扣过
        let imgDataUrl = ctx.getImageData(0, 0, width, height); //获取像素点
        let data = imgDataUrl.data;
        for (let i = 0; i < data.length; i += 4) {
            // 得到 RGBA 通道的值
            let r = data[i];
            let g = data[i + 1];
            let b = data[i + 2];

            /**
             * function 判断颜色是不是属于背景色
             *
             * @param numerical
             * @param index
             * @returns {boolean}
             */
            let isIn = (numerical, index) => {
                if (selfImageData[3] == 0) {
                    isPNG = false;
                    return false;
                }
                return (
                    (numerical > parseInt(selfImageData[index]) - 65 &&
                        numerical < parseInt(selfImageData[index]) + 65) ||
                    numerical > 195
                ); // 去掉边缘色和浅色
            };

            if ([r, g, b].every(isIn)) {
                data[i + 3] = 0; // 设置背景透明
            }
        }
        // 将修改后的代码复制回画布中
        ctx.putImageData(imgDataUrl, 0, 0);
    }

    average(arr) {
        let arry = [];
        arr.forEach(item => {
            arry.push(item.split(','));
        });
        arry.forEach((list, i) => {
            list.forEach((item, j) => {
                arry[i][j] = parseInt(item);
            });
        });
        return [
            (arry[0][0] + arry[1][0] + arry[2][0] + arry[3][0]) / 4,
            (arry[0][1] + arry[1][1] + arry[2][1] + arry[3][1]) / 4,
            (arry[0][2] + arry[1][2] + arry[2][2] + arry[3][2]) / 4,
            (arry[0][3] + arry[1][3] + arry[2][3] + arry[3][3]) / 4,
        ];
    }

    trim(c) {
        let ctx = c.getContext('2d'),
            copy = document.createElement('canvas').getContext('2d'),
            pixels = ctx.getImageData(0, 0, c.width, c.height),
            l = pixels.data.length,
            i,
            bound = {
                top: null,
                left: null,
                right: null,
                bottom: null,
            },
            x,
            y;

        for (i = 0; i < l; i += 4) {
            if (pixels.data[i + 3] !== 0) {
                x = (i / 4) % c.width;
                y = ~~(i / 4 / c.width);

                if (bound.top === null) {
                    bound.top = y;
                }

                if (bound.left === null) {
                    bound.left = x;
                } else if (x < bound.left) {
                    bound.left = x;
                }

                if (bound.right === null) {
                    bound.right = x;
                } else if (bound.right < x) {
                    bound.right = x;
                }

                if (bound.bottom === null) {
                    bound.bottom = y;
                } else if (bound.bottom < y) {
                    bound.bottom = y;
                }
            }
        }

        let trimHeight = bound.bottom - bound.top,
            trimWidth = bound.right - bound.left,
            trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

        copy.canvas.width = trimWidth;
        copy.canvas.height = trimHeight;
        copy.putImageData(trimmed, 0, 0);

        // open new window with trimmed image:
        return copy.canvas;
    }


}
